<template>
  <div class="mb-1">
    <div class="row">
      <div class="col-12 mb-2" v-if="detectionEvent.video && detectionEvent.video.url">
        <video
          :src="detectionEvent.video.url"
          class="img-fluid w-100"
          controls
        />
      </div>
      <div class="col-12 mb-2" v-if="detectionEvent.media && detectionEvent.media.url">
        <img
          :src="detectionEvent.media.url"
          class="img-fluid w-100"
          @click="openImageModal(detectionEvent.media.url)"
          v-b-modal.image_modal
        />
      </div>
    </div>
    <table class="table table-sm">
      <tr>
        <th>{{ $t("grid.slots.info.detection_events.default.title") }}</th>
        <td>{{ detectionEvent.formatted_event_type }}</td>
      </tr>
      <tr v-if="eventIncidentType">
        <th>{{ $t("grid.slots.info.detection_events.labels.incident_type") }}</th>
        <td>{{ eventIncidentType }}</td>
      </tr>
      <tr v-if="eventDescription">
        <th>{{ $t("grid.slots.info.detection_events.labels.description") }}</th>
        <td>{{ eventDescription }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.info.detection_events.labels.camera_name") }}</th>
        <td>{{ detectionEvent.camera_proxy.camera.name }}</td>
      </tr>
      <tr>
        <th>{{ $t("detection_event.event_created_at") }}</th>
        <td>{{ detectionEvent.created_at }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import {} from "bootstrap-vue";
import store from "@/store";
import ImageError from '../../../assets/images/placeholder-user.png';

export default {
  components: {},
  props: {
    detectionEvent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imgError: ImageError,
    }
  },
  computed: {
    eventIncidentType() {
      return this.getMetadataValue("incident_type");
    },
    eventDescription() {
      return this.getMetadataValue("description");
    },
  },
  methods: {
    getMetadataValue(key) {
      const metadata = this.detectionEvent.metadata || {};
      const values = Array.isArray(metadata.objects)
        ? metadata.objects.map(object => object && object[key])
        : [metadata[key]];
      const value = values.find(item => (
        typeof item === "number" ||
        (typeof item === "string" && item.trim())
      ));

      return typeof value === "string" ? value.trim() : value;
    },
    async openImageModal(imageUrl) {
      await store.dispatch("image_modal/imageUrl", imageUrl);
    },
  }
};
</script>
